import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-home",
  "use": "medexpert-home-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-home\">\r\n<path opacity=\"0.2\" d=\"M3 9H15V14C15 15.105 14.105 16 13 16H5C3.895 16 3 15.105 3 14V9Z\" />\r\n<path d=\"M8.368 0.206004C8.73 -0.0679965 9.26999 -0.0679965 9.63099 0.206004L16.67 5.544C17.337 6.049 16.924 7.001 16.038 7.001H1.96C1.074 7.001 0.661995 6.05 1.328 5.544L8.368 0.206004Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol